<template>
  <div class="sold-page">
    <lazy-image
      :src="getPhotoByIndex(0).xl"
      alt="Real property"
      class="sold-page-photo"
    />
    <div class="sold-page-content">
      <div class="sold-page-address">{{getFullAddress}}</div>
      <div class="sold-page-label">Sold</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('tour', ['getFullAddress', 'getPhotoByIndex'])
    }
  };
</script>

<style lang="scss">
  @charset "utf-8";

  @import url("https://fonts.googleapis.com/css?family=Fira+Sans:400,700&subset=latin-ext");

  $family-sans-serif: 'Fira Sans', sans-serif;
  $body-color: #f5f5f5;
  $body-background-color: #fff;

  @import "~bulma/sass/utilities/_all.sass";
  @import "~bulma/sass/base/_all.sass";

  .sold-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg,rgba(232,66,86,.8),rgba(131,52,62,.8) 30%,rgba(42,40,40,.9));
    }

    &-photo {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &-content {
      position: relative;
      z-index: 5;
      max-width: 390px;
      transform: rotate(-15deg);
      text-align: center;

      @include tablet() {
        max-width: 520px;
      }
    }

    &-address {
      margin-bottom: 5px;
      font-size: 24px;
      line-height: 1.1;
    }

    &-label {
      min-width: 300px;
      padding: 8px;
      background-color: #9b5959;
      text-transform: uppercase;
      letter-spacing: 5px;
      font-size: 50px;
      font-weight: 700;
      line-height: 1;
    }
  }
</style>
